import { GenericProductType, Policy, PolicyTypeIconConstants } from '@amfam/policy/models';

export class GoPaperlessModel {
  private icon: string;

  // TODO @jjc - look at reusing existing logic for this
  constructor(private policy: Policy) {
    switch (policy.generalizedProductType) {
      case GenericProductType.Home:
        this.icon = PolicyTypeIconConstants.HOME;
        break;
      case GenericProductType.Auto:
        this.icon = PolicyTypeIconConstants.AUTO;
        break;
      case GenericProductType.Umbrella:
        this.icon = PolicyTypeIconConstants.UMBRELLA;
        break;
    }
  }
}
